import Axios from '@/axios'

// 获取用户组
// 接口权限名：web:userGroup:index
export const GetUserGroup = data => {
  return Axios({
    url: '/device-manager/web/uem/user-group/index',
    method: 'POST',
    type: 'json',
    data
  })
}

// 新增用户组
// 接口权限名：web:userGroup:create
export const NewUserGroup = data => {
  return Axios({
    url: '/device-manager/web/uem/user-group/create',
    method: 'POST',
    type: 'json',
    data
  })
}

// 编辑用户组
// 接口权限名：web:userGroup:update
export const EditUserGroup = data => {
  return Axios({
    url: `/device-manager/web/uem/user-group/update/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 删除用户组
// 接口权限名：web:userGroup:delete
export const DeleteUserGroup = data => {
  return Axios({
    url: `/device-manager/web/uem/user-group/delete/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 获取系统权限列表
export const GetSysAuths = params => {
  return Axios({
    url: '/device-manager/web/uem/user-group-auth/show_all_auth',
    method: 'POST',
    type: 'json',
    params
  })
}

// 查询某个用户组的权限
// 接口权限名：web:userGroup-auth:show
export const UserGroupListAuth = data => {
  return Axios({
    url: `/device-manager/web/uem/user-group/user_group_list_auth/${data.id}`,
    method: 'POST',
    type: 'json'
  })
}

// 更新某个用户组的权限设置
// 接口权限名：web:userGroupAuth:put
export const UpdateGroupAuth = data => {
  return Axios({
    url: '/device-manager/web/uem/user-group/put_user_group_auth',
    method: 'POST',
    type: 'json',
    data
  })
}

// 查询某用户所属用户组
// 接口权限名：web:userGroup-divide:indexForUser
export const IndexUserDivideForUser = data => {
  return Axios({
    url: `/device-manager/web/uem/user-group/index_user_divide_for_user/${data.userId}`,
    method: 'POST',
    type: 'json',
    data
  })
}
